module.exports = __webpack_public_path__ + "static/img/14064B_3_5_20170509_LC.171218b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14064B_3_5_20170509_LC.png
// module id = y+yM
// module chunks = 0